import { Infobulle } from './Infobulle';

/**
 * Un document PDF, en icône : l'image fournie par Georges le 2026-10-08
 * (page grise au coin replié, bandeau rouge « PDF »), en couleur comme
 * les icônes Gmail et Excel de `BoutonsIcone`, seulement réduite — elle
 * remplace l'icône grise au trait du 2026-10-03. Le fichier est servi en
 * 50 px et affiché en 20 px, net sur les écrans haute densité.
 *
 * Le sens survit dans `alt` et dans l'infobulle commune : une icone
 * seule ne se lit pas au lecteur d'ecran.
 */
export function IconePdf({ libelle }: { libelle: string }) {
  return (
    <Infobulle texte={libelle} className="inline-flex">
      <img src="/assets/icone-pdf.png" alt={libelle} className="h-5 w-5 shrink-0" draggable={false} />
    </Infobulle>
  );
}
